import {ActionTypes} from "modules/redux_types";
import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};

const types = [
  "AMENDMENT_CLAUSE_CHANGES_ADD",
  "AMENDMENT_CLAUSE_CHANGES_CLEAR",
  "AMENDMENT_CLAUSE_CHANGE_ERROR",
] as const;

types.forEach(type => createReduxPromiseActionType(actionTypes, type));

export type ActionType = typeof types[number];

export type AmendmentsActionTypes = ActionTypes<ActionType>;

export default actionTypes as AmendmentsActionTypes;
